declare global {
  interface Window {
    SgsLauncher?: {
      scanBarcode?: (callbackName?: string) => void;
      insertText?: (text: string) => void;
      suppressSoftKeyboard?: () => void;
      getDeviceId?: () => string;
      getTabletMobility?: () => string;
      readPrinterPref?: (workflowKey: string) => string;
      writePrinterPref?: (workflowKey: string, printer: string) => void;
      /** Manufacturing tablet command bar. False disables the report exclamation button. */
      setReportIssueEnabled?: (enabled: boolean) => void;
    };
    /** Launcher passes a JPEG data URL after the report button captures the WebView. */
    __sgsOnReportScreenshot?: (dataUrl: string) => void;
    /** Launcher asks Hub to push the current report-button enabled state after a page load. */
    __sgsSyncReportIssueButton?: () => void;
    /** Page-level barcode handler used by the manufacturing tablet Scan button. */
    __sgsOnBarcodeScan?: (text: string) => void;
    /**
     * Invoked by the manufacturing tablet launcher before command-bar Exit finishes HubActivity.
     * Hub registers labor/presence clock-out here because WebView often skips `pagehide`.
     */
    __sgsOnLauncherExit?: () => void;
    __sgsDeviceId?: string;
    __sgsTabletMobility?: string;
  }
}

/** True when the page runs inside the manufacturing tablet launcher WebView. */
export function isSgsLauncherAvailable(): boolean {
  return typeof window !== "undefined" && window.SgsLauncher != null;
}

/**
 * Opens the tablet native barcode scanner when available.
 * Returns false when the launcher bridge is not present (desktop browser).
 */
export function requestNativeBarcodeScan(onResult: (text: string) => void): boolean {
  const launcher = window.SgsLauncher;
  if (launcher?.scanBarcode == null) {
    return false;
  }

  const callbackName = `__sgsScan_${String(Date.now())}_${Math.random().toString(36).slice(2, 10)}`;
  const windowWithCallback = window as unknown as Record<string, (text: string) => void>;
  windowWithCallback[callbackName] = (text: string) => {
    delete windowWithCallback[callbackName];
    onResult(text);
  };
  launcher.scanBarcode(callbackName);
  return true;
}
